import { HOME_PAGE_MODULES } from '#pplx/frontend/apps/ask/o11y/pageTTVModules.js';
// codescythe-ignore-next-line import-conflict-preload -- dedicated entrypoint preload
import { Home } from '#pplx/frontend/apps/ask/page-components/home/index.js';
import { bootstrap } from '#pplx/frontend/apps/ask/spa/bootstrap.js';
import { startSpa } from '#pplx/frontend/apps/ask/spa/startSpa.js';
startSpa({
    boot: () => bootstrap({
        '/': {
            Component: Home,
            modules: HOME_PAGE_MODULES,
        },
    }),
});
//# sourceMappingURL=index.js.map